import workspaceQuery from 'graphql/queries/customer/CustomerSpecialPricesWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/customer/CustomerSpecialPricesListQuery.graphql';
import instanceQuery from 'graphql/queries/customer/CustomerSpecialPricesQuery.graphql';
import defaultQuery from 'graphql/queries/customer/CustomerSpecialPricesDefault.graphql';
import mutationQuery from 'graphql/mutations/customer/CustomerSpecialPricesMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/customer/CustomerSpecialPriceTempMutation.graphql';
import fragment from 'graphql/fragments/customer/CustomerSpecialPriceFragment.graphql';

const CustomerSpecialPrices = {
  type: 'CustomerSpecialPrice',
  title: 'Customer Special Prices',
  formTitle: 'Special Price',
  formUrl: '/Customers/SpecialPrices/Details/',
  workspaceUrl: '/Sales/CustomerPricing/SpecialCustomerPrices/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'customer',
  },
  fragment,
  screenReference: 'CUSTOMER_SPECIAL_PRICES',
};

export default CustomerSpecialPrices;
